var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./base.service";
export class OrderService extends BaseService {
    constructor(ellCommerce) {
        super(ellCommerce, "order");
    }
    getOrder(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `orders/${orderId}`,
                    method: "GET",
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getOrdersByCartId(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `orders/cart/${cartId}`,
                    method: "GET",
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getOrdersByUser(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `orders/user/${userId}`,
                    method: "GET",
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getOrdersFirstPage(userId, orderSearch) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `orders/firstpage/${userId}`,
                    method: "POST",
                    data: orderSearch
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getOrdersNextPage(userId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `orders/nextpage/${userId}`,
                    method: "POST",
                    data: context
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getOrdersPreviousPage(userId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `orders/prevpage/${userId}`,
                    method: "POST",
                    data: context
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    refundOrder(orderId, orderRefund) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `orders/${orderId}/refund`,
                    method: "POST",
                    data: orderRefund
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
}
